export const COLUMN_INTER_INSTRUMENT: string = "currencyPair";
export const COLUMN_INTER_DESK_ID: string = "traderGroupId";
export const COLUMN_INTER_ORDER_PRODUCT: string = "product";
